import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LastUpdateService {
    lastUpdateTime = new BehaviorSubject<Date>(new Date());

    constructor() {}

    public setLastUpdatedTime() {
        this.lastUpdateTime.next(new Date());
    }

    public getLastUpdatedTime() {
        return this.lastUpdateTime;
    }
}
